// actions.js
import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getPaymentVouchers: ['itemNumber'],
  getPaymentVouchersSuccess: null,
  getPaymentVouchersRequest: null,
  getPaymentVouchersFailure: ['error']
});

export { Creators, Types };
